import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import { IconBucket } from '@/res/icons'
import { NAMESPACE_S3_BUCKET } from '@/res/namespaces'

const MainSection: React.FC = () => {
  const { t } = useTranslation(NAMESPACE_S3_BUCKET)

  return (
    <>
      <div className="container grid grid-rows-auto grid-auto-flow-dense grid-cols-1 md:gap-4 md:grid-flow-col justify-items-center md:justify-items-stretch items-center pb-16 xl:pb-20">
        <div className="text-center md:text-left">
          <div className="mb-[50px] xl:mb-[100px] max-w-[435px] mt-4 md:mt-0 xl:mt-[100px]">
            <h3 className="mb-[25px] text-left font-bold text-[28px] leading-[38px] sm:text-[35px] sm:leading-[45px] xl:text-[48px] xl:leading-[58px]">
              {t('main_section_title')}
            </h3>
            <p className="text-[#7B8794] text-left text-tiny leading-5 xl:text-md xl:leading-7">
              {t('main_section_description')}
            </p>
          </div>
          <Link href="#cost">
            <button className="rounded-lg text-sm xl:text-md text-white bg-[#428BF9] py-[15px] px-[55px]">
              {t('connect')}
            </button>
          </Link>
        </div>
        <div className="order-first md:order-none">
          <IconBucket className="w-[230px] md:w-[300px] lg:w-[350px] xl:w-[550px]" />
        </div>
      </div>
    </>
  )
}

export default MainSection
